import { matchPath, Navigate } from "react-router-dom";
import LoggedInLayout from "../layouts/loggedInLayout";
import ResetPassword from "../pages/account/resetPassword";
import Admin from "../pages/admin/admin";
import ForgotPassword from "../pages/login/forgotPassword";
import Login from "../pages/login/login";
import SettingsPage from "../pages/settings/settings";
import Insights from "../pages/workspace/components/insights";
import Intelligence from "../pages/workspace/tabs/intelligence";
import Planning from "../pages/workspace/tabs/planning";
import Scenarios from "../pages/workspace/tabs/scenarios";
import Simulator from "../pages/workspace/tabs/simulator";
import Workspace from "../pages/workspace/workspace";

export interface AppRoute {
    path?: string;
    element?: React.ReactNode | null;
    index?: true;
    children?: AppRoute[];
}

export function findRoute(path: string, routes: AppRoute[] = appRoutes): AppRoute | null {
    for (const route of routes) {
        if (route.path) {
            const match = matchPath({
                path: route.path
            }, path);

            if (match) {
                return route;
            }
        }

        if (route.children) {
            const match = findRoute(path, route.children);
            if (match) {
                return match;
            }
        }
    }

    return null;
}

const appRoutes: AppRoute[] = [
    {
        path: "/",
        element: <Login />
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/forgot-password",
        element: <ForgotPassword />
    },
    {
        path: "/account/reset-password",
        element: <ResetPassword />
    },
    {
        path: "/app",
        element: <LoggedInLayout />,
        children: [
            {
                index: true,
                element: <Navigate to="workspace/planning" replace />
            },
            {
                path: "workspace",
                element: <Workspace />,
                children: [
                    {
                        index: true,
                        element: <Navigate to="planning" replace />
                    },
                    {
                        path: "planning",
                        element: <Planning />
                    },
                    {
                        path: "portfolio-intelligence",
                        element: <Intelligence />
                    },
                    {
                        path: "simulator",
                        element: <Simulator />
                    },
                    {
                        path: "scenarios",
                        element: <Scenarios />
                    },
                    {
                        path: "insights",
                        element: <Insights />
                    }
                ]
            },
            {
                path: "admin",
                element: <Admin />
            },
            {
                path: "settings",
                element: <SettingsPage />
            }
        ]
    }
];

export default appRoutes;
